<template>
    <div class="black-friday-advantages" :class="theme">
        <h4 class="black-friday-advantages__title">
            Highlights of your personalized plan:
        </h4>
        <div class="black-friday-advantages__list">
            <div v-for="(text, index) in advantages" :key="index" class="list-item">
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.6 1.1499L5.84033 8.81826C5.50851 9.35286 4.77132 9.45184 4.31024 9.02369L1 5.9499" stroke-width="2" stroke-linecap="round"/>
                </svg>

                <p>{{ text }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlackFridayAdvantages',
    props: ['theme'],
    setup() {
        return {
            advantages: [
                'Weight loss tailored to your lifestyle',
                'Nutrition guidance and feedback',
                'Personal insights to stay on track',
                'Healthy habits that last'
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.black-friday-advantages {
    &.light {
        --text-color: #323653;
        --icon-color: #7D8BF7;
    }

    &.dark {
        --text-color: #FFFFFF;
        --icon-color: #98A4FF;
    }

    &__title {
        font-weight: 700;
        font-size: 1.5rem;
        letter-spacing: 0.02rem;
        margin: 1.5rem 0;
        color: var(--text-color);
    }

    &__list {
        display: flex;
        flex-direction: column;

        .list-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 0.5rem;

            svg path {
                stroke: var(--icon-color)
            }

            p {
                color: var(--text-color);
                margin: 0;
                margin-left: 0.8rem;
            }
        }
    }
}
</style>
